<div class="swc">
  <h2 mat-dialog-title class="swc__title">
    <span class="swc__icon-badge">
      <mat-icon class="swc__icon material-symbols-outlined">warning</mat-icon>
    </span>
    <span>Save without any contacts?</span>
  </h2>
  <mat-dialog-content class="swc__content">
    <p>
      An organisation only appears in the list once it has at least one contact. Save now and
      {{ data.organisationName }} won't be listed — add a person or department first to keep it.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions class="swc__actions">
    <button type="button" class="swc__btn swc__btn--secondary" (click)="onCancel()">Go back and add contacts</button>
    <button type="button" class="swc__btn swc__btn--primary" (click)="onConfirm()">
      Save anyway
      <span class="sgl-arrows" aria-hidden="true"></span>
    </button>
  </mat-dialog-actions>
</div>
